import {Injectable} from '@angular/core';
import {ActivePoliceStore} from '@app/core/state/active-police/active-police.store';
import {select} from "@ngneat/elf";
import {toBoolean} from "@app/core/util/check.util";

@Injectable({ providedIn: 'root' })
export class ActivePoliceQuery {

  isPoliceLoading$ = this.store.data.pipe(select(sessionStore => toBoolean(sessionStore.policeLoading)));
  isPoliceLoadingError$ = this.store.data.pipe(select(sessionStore => toBoolean(sessionStore.policeLoadingError)));
  currentPolice$ = this.store.data.pipe(select(sessionStore => sessionStore.police));
  isPolizzenVertraegeLoading$ = this.store.data.pipe(select(sessionStore => toBoolean(sessionStore.vertraegeLoading)));
  currentPolizzenVertraege$ = this.store.data.pipe(select(sessionStore => sessionStore.vertraege));

  isVertragLoading$ = this.store.data.pipe(select(sessionStore => sessionStore.vertragLoading));
  isVertragLoadingError$ = this.store.data.pipe(select(sessionStore => sessionStore.vertragLoadingError));
  currentVertrag$ = this.store.data.pipe(select(sessionStore => sessionStore.vertrag));


  currentVertragKlauseln$ = this.store.data.pipe(select(sessionStore => sessionStore.vertragKlauseln));
  isVertragKlauselnLoading$ = this.store.data.pipe(select(sessionStore => sessionStore.vertragKlauselnLoading));


  currentVertragAvbs$ = this.store.data.pipe(select(sessionStore => sessionStore.avbs));

  currentVertragPositionen$ = this.store.data.pipe(select(sessionStore => sessionStore.positionen));
  isVertragPositionenLoading$ = this.store.data.pipe(select(sessionStore => sessionStore.positionenLoading));

  isPositionLoading$ = this.store.data.pipe(select(sessionStore => sessionStore.positionLoading));
  isPositionLoadingError$ = this.store.data.pipe(select(sessionStore => sessionStore.positionLoadingError));
  currentPosition$ = this.store.data.pipe(select(sessionStore => sessionStore.position));


  currentPositionKlauseln$ = this.store.data.pipe(select(sessionStore => sessionStore.positionKlauseln));
  isPositionKlauselnLoading$ = this.store.data.pipe(select(sessionStore => sessionStore.positionKlauselnLoading));


  constructor(protected store: ActivePoliceStore) {
  }

}
